import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";

export default function useAuth() {
    const auth = computed(() => usePage().props.auth);
    const check = () => auth.value.loggedIn;

    return { auth, check };
}
